import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/providers/Main.js");
